<template>
  <div class="ren-decoration-cp ren-decoration-cp-content-moment-caption">
    <p>{{ caption }}</p>
    <small v-if="meta">{{ meta }}</small>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { booleanValue, previewDataRecord, stringValue } from '../../../previews/preview-helpers'
import type { WidgetPreviewProps } from '../../types'

const props = defineProps<WidgetPreviewProps>()
const data = computed(() => previewDataRecord(props.componentData))
const caption = computed(() => stringValue(data.value.caption ?? data.value.content ?? data.value.title, '动态说明'))
const meta = computed(() => {
  const parts: string[] = []
  if (booleanValue(props.component.props?.showPublisher, true) && data.value.publisher) parts.push(String(data.value.publisher))
  if (booleanValue(props.component.props?.showPublishedAt, true) && data.value.publishedAt) parts.push(String(data.value.publishedAt))
  return parts.join(' · ')
})
</script>

<style scoped>
.ren-decoration-cp-content-moment-caption p {
  margin: 0;
}
.ren-decoration-cp-content-moment-caption small {
  color: var(--ren-theme-muted);
  font-size: 12px;
}
</style>
